import { render, staticRenderFns } from "./ComboboxTerritoriosCategorias.vue?vue&type=template&id=d06b3c5a"
import script from "./ComboboxTerritoriosCategorias.vue?vue&type=script&lang=js"
export * from "./ComboboxTerritoriosCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports